<template>
  <div class="factoryStock-bd tb" style="padding: 0">
    <custom-tab v-model="formSearch.stockState" :list="tabList"></custom-tab>
    <stock-in v-if="formSearch.stockState === 2"></stock-in>
    <stock-out v-else></stock-out>
  </div>
</template>

<script>
// import apis from '@/utils/apis';
import stockIn from './children/stock_in.vue';
import stockOut from './children/stock_out.vue';

export default {
  name: 'factoryStock',
  mixins: [],
  components: { stockIn, stockOut },
  data() {
    return {
      provide: true,
      tableSelect: [],

      formSearch: {
        protocolCode: '',
        search: '',
        stockState: 2,
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
        productCode: '',
        imsi: '',
        tcpVersion: '',
        batteryCharge: [],
        dataTimes: [],
        websiteName: '',
      },
      tableList: [],
      totalRows: 0,
      dialogVisible: false,
      dialogModel: {},
      dialogVisible2: false,
      dialogModel2: {},
      tabList: [],
    };
  },
  activated: function () {
    // this.getTableList();
  },
  mounted: function () {
    this.getFuncView(null, () => {
      const tab = [];
      if (this.funcView.stock_list) {
        tab.push({ name: this.$t('dms_factoryStock.yi_ru_ku'), value: 2 });
      }
      if (this.funcView.out_stock_list) {
        tab.push({ name: this.$t('dms_factoryStock.yi_chu_ku'), value: 3 });
      }
      this.tabList = tab;
    });
  },
  methods: {},
};
</script>

<style lang="scss">
.factoryStock-bd {
  .stock-wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    overflow: hidden;
  }
}
</style>
